export default(givenFiles = [], secureUpload = true) => ({
  files: givenFiles,
  errorMessage: undefined,
  assets: givenFiles,
  progress: {},
  secured: secureUpload,
  init() {
    this.files.forEach(file => this.progress[file.name] = 1);
  },
  removeFile(index) {
    const _file = this.files[index];
    this.assets = this.assets.filter(asset => asset.name !== _file.name);
    delete this.progress[_file.name];

    this.files.splice(index, 1);
  },
  resetErrorMessage() {
    this.errorMessage = undefined;
  },
  showDetails() {
    return this.files !== null && this.files !== undefined && this.files.length !== 0;
  },
  showUploader() {
    return !this.showDetails();
  },
  filesUpdated(_, oldValue) {
    const token = this.$el.closest('form').querySelector('input[name="authenticity_token"]');

    this.files.filter(file => !oldValue.includes(file)).forEach(file => {
      this.resetErrorMessage();
      this.progress[file.name] = 0;
      fetch('/attachments/external_upload', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': token.value
        },
        body: JSON.stringify({
          content_type: file.type,
          secured: this.secured,
          size: file.size,
          name: file.name
        })
      })
      .then(response => response?.status >= 500 ? response : response.json())
      .then(action => {
        if (typeof(action?.status) == "number" && action.status >= 500) {
          this.errorMessage = "Error while uploading file: " + file.name + "<br>Details: " + action.statusText;
          this.removeFile(this.files.indexOf(file));
        } else {
          this.doUpload(action.result.asset, file, action.result.url, action.result.fields);
        }
      })
      .catch(error => {
        this.errorMessage = error.message;
        this.removeFile(this.files.indexOf(file));
      });
    });
  },
  doUpload(asset, file, url, fields) {
    const formData = new FormData();

    Object.keys(fields).forEach(key => {
      formData.append(key, fields[key]);
    });

    // Actual file has to be appended last.
    formData.append("file", file);

    const xhr = new XMLHttpRequest();
    xhr.upload.onprogress = (event) => { this.progress[file.name] = event.loaded/event.total }
    xhr.open("POST", url, true);
    xhr.send(formData);
    xhr.onload = (evt) => {
      if(xhr.status === 201) {
        this.assets = this.assets.concat(asset);
      } else {
        this.removeFile(this.files.indexOf(file));
        this.errorMessage = evt.message;
      }
    };
  }
});
